import BaseHttp from "@/api/httpHelper";
import apiGwClient from "@/api/api.gateway";
import type { IRevenueResponse, IRevenue } from "@/types/response";
import type { IRevenueCreate, IUpdateRevenue } from "@/types/requests";

class RevenueService extends BaseHttp {
  async getRevenues(pageNumber: number, pageSize: number, searchTerm: string) {
    const { data } = await this.get<IRevenueResponse>(
      "",
      { pageNumber, pageSize, searchTerm },
      { requestKey: "getRevenues" }
    );
    return data;
  }

  async createRevenue(body: IRevenueCreate) {
    const { success, error } = await this.post<string>("", body, {
      requestKey: "createRevenue",
    });
    return { success, error };
  }

  async getRevenueById(id: string) {
    const { data } = await this.get<{ revenue: IRevenue }>(
      `/${id}`,
      {},
      { requestKey: "getRevenueById" }
    );
    return data;
  }

  async deleteRevenue(id: string) {
    const { success, error } = await this.delete<string>(
      `/${id}`,
      {},
      { requestKey: "deleteRevenue" }
    );
    return { success, error };
  }

  async updateRevenue(id: string, body: IUpdateRevenue) {
    const { data, success, error } = await this.put<string>(`/${id}`, body, {
      requestKey: "updateRevenue",
    });
    return { data, success, error };
  }

  async addRevenueAmount(id: string, body: IRevenueAmountAdd) {
    const { data, success, error } = await this.post<string>(
      `/${id}/pay`,
      body,
      {
        requestKey: "addRevenueAmount",
      }
    );
    return { data, success, error };
  }
}

export default new RevenueService(apiGwClient, "/api/v1/revenues");
